module.exports = __webpack_public_path__ + "img/3-消息.a3f389b5.svg";